import { useContext } from 'react';

import { CategoricalBarChartThresholdsContext } from '../contexts/CategoricalBarChartThresholds.context.js';

export const useCategoricalBarChartThresholds = () =>
  useContext(CategoricalBarChartThresholdsContext);
